import React from 'react';
import { GptTableRow } from './GptTableRow';

export const ChatGptTable = ({
  projectId,
  version,
  externalApis,
  externalapi,
  handleClone,
  handleDelete,
}) => {
  return (
    <table className="table table-bordered table-hover table-sm table-word-break connector-list">
      <thead>
        <tr>
          <th>Name</th>
          <th>Model</th>
          <th>Request Collection</th>
          <th>Created Date</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {externalApis.map((externalApi) => (
          <GptTableRow
            key={externalApi.uuid}
            projectId={projectId}
            version={version}
            externalApi={externalApi}
            externalapi={externalapi}
            handleClone={handleClone}
            handleDelete={handleDelete}
          />
        ))}
      </tbody>
    </table>
  );
};
